import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Button from 'components/commercetools-ui/atoms/button';
import Drawer from 'components/commercetools-ui/atoms/drawer';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Market } from 'components/commercetools-ui/organisms/header/types';
import FlagIcons from 'components/icons/flags';
import { MarketContext } from 'context/market';
import { useFormat } from 'helpers/hooks/useFormat';
import Dropdown from 'components/commercetools-ui/atoms/dropdown';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { useParams } from 'next/navigation';
import Spinner from '../spinner';

const MarketButton = () => {
  const [showMarket, setShowMarket] = useState(false);
  const { market: selectedMarket, markets, handleMarket } = useContext(MarketContext);
  const { locale } = useParams();

  useEffect(() => {
    //set locale session cookie
    document.cookie = `locale=${locale}; path=/`; 
  }, [locale]);

  // Spinner state
  const [loading, setLoading] = useState(false);

  const handleMarketClick = (market: Market) => {
    if(locale!==market.flag.toLowerCase()){

    // Show the spinner
    setLoading(true);

    //set "do not show geo website mistmatch popup" cookie
    document.cookie = "geo-location-and-website-mismatch-popup-displayed=yes; path=/"; 
    
    handleMarket(market);
    }
  };
  
  const sortDropdownButton = () => {
    return (
      <>
        {loading && <Spinner />} {/* Show spinner if loading */}

        {selectedMarket && (
          <Button
            variant="ghost"
            iconPosition="right"
            icon={<ChevronDownIcon strokeWidth={2} className="w-16 text-neutral-100" />}
            className="flex items-center bg-[#2B2C39] text-neutral-100 hover:underline focus:outline-none" >
            <Typography className="text-14 [@media(max-width:1150px)]:text-12 font-normal  ">{selectedMarket?.region}</Typography>
          </Button>
        )}
      </>
    );
  };
  const sortDropdownButtonClassnames = useCallback((open?: boolean) => {
    return ``;
  }, []);
  return (
    <>
      {selectedMarket && (
        <div className="flex w-fit justify-center">
          <Dropdown
            customButtonElement={sortDropdownButton()}
            customButtonClassNames={sortDropdownButtonClassnames}
            customMenuWrapperClassNames={
              'absolute lg:mt-2 w-full right-0  z-[99] focus:border-none focus:outline-none rounded-xs'
            }
          >
            {markets.map((market) => (
              <Button
                key={market.flag}
                size='full'
                variant="ghost"
                onClick={() => handleMarketClick(market)}
                className={`flex w-full items-center justify-start hover:bg-neutral-200 ${
                  selectedMarket.region === market.region && 'bg-neutral-200'
                }`}
              >
                <Typography className="w-full text-center text-12 font-normal text-primary-black">{market.region}</Typography>
              </Button>
            ))}
          </Dropdown>
        </div>
      )}
    </>
  );
};
export default MarketButton;
